import {useEffect, useRef, useState} from 'react';
import {useFlujosAddressComplement} from "hooks/useFlujosAddressComplement";

import Search from "components/FlujosAddressComplement/Search";
import Form from "components/FlujosAddressComplement/Form";
import Table from "components/FlujosAddressComplement/Table";
import SpinnerBootrap from 'components/SpinnerBootrap';

function FlujosAddressComplement(){
 const {
    allFlujosAddressComplement,
    flujosAddressComplement, 
    loading, 
    page, 
    totalPages, 
    status, 
    deleteFlujoAddressComplement, 
    updateFlujoAddressComplement, 
    createFlujoAddressComplement, 
    getFlujosAddressComplement, 
    setPage,
    itemsPerPage,
    setItemsPerPage,
} = useFlujosAddressComplement();

 const [isSearched, setIsSearched] = useState({
     search: '',
     option: '',
     state: false
 })

 const searchFormRef = useRef();

 const resetSearch = () => {
    setIsSearched({
        search: '',
        option: '',
        state: false
    })
    searchFormRef.current?.reset();
 }

 useEffect(() => {
    if(status !== 401 ) return
    localStorage.removeItem('token')
    window.location.href="/login"
 }, [status])

 return (
 <div className="container">
     <div className="row my-md-4">
         <h4 className="d-flex justify-content-center">Flujos Address Complement</h4>
         <div className="col-12">
             <Search
                getFlujosAddressComplement={getFlujosAddressComplement}
                setIsSearched={setIsSearched} 
                formRef={searchFormRef}
             />
         </div>
         <div className="col-12">
             <Form createFlujoAddressComplement={createFlujoAddressComplement} updateFlujoAddressComplement={updateFlujoAddressComplement} setIsSearched={setIsSearched}/>
         </div>
         <div className="col-12">
             {loading && <SpinnerBootrap/>}
             <Table
                allFlujosAddressComplement={allFlujosAddressComplement}
                flujosAddressComplement={flujosAddressComplement}
                getFlujosAddressComplement={getFlujosAddressComplement}
                deleteFlujoAddressComplement={deleteFlujoAddressComplement}
                totalPages={totalPages}
                setPage={setPage}
                page={page}
                isSearched={isSearched}
                setIsSearched={setIsSearched}
                hasSearched={isSearched.state}
                itemsPerPage={itemsPerPage}
                setItemsPerPage={setItemsPerPage}
                resetSearch={resetSearch}
                totalFlujosAddressComplement={allFlujosAddressComplement.length ?? 0}
             />
         </div>
     </div>
 </div>
 )
}

export default FlujosAddressComplement